import { makeStyles } from '@material-ui/core';

// Collapsed sidebar: the full wordmark is shown small and clipped to the
// closed drawer width (shows the sunburst + start of the mark). Swap in an
// icon-only asset here later for a cleaner collapsed state.
const useStyles = makeStyles({
  img: {
    height: 28,
    width: 'auto',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return <img className={classes.img} src="/autumngames.png" alt="Autumn Games" />;
};
